import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 23.998"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#743A3A",
      d: "M9.036 13.103c1.24 0 1.86.62 1.86 1.86v7.176c0 1.239-.62 1.859-1.86 1.859H1.86c-1.24 0-1.859-.62-1.859-1.86v-7.176c0-1.24.62-1.859 1.86-1.859h7.176Zm5.238.41a1.17 1.17 0 0 1 1.175 1.174v8.136a1.172 1.172 0 0 1-2.344 0v-8.14c0-.646.523-1.17 1.169-1.17Zm4.273 2.369a1.17 1.17 0 0 1 1.175 1.17v5.771a1.172 1.172 0 0 1-2.344 0v-5.772a1.169 1.169 0 0 1 1.17-1.17Zm4.262-2.37.016.001a1.17 1.17 0 0 1 1.16 1.174v8.136a1.172 1.172 0 0 1-2.344 0v-8.136a1.17 1.17 0 0 1 1.184-1.174h-.016ZM9.036 0c1.24 0 1.86.62 1.86 1.86v7.175c0 1.24-.62 1.86-1.86 1.86H1.86C.62 10.894 0 10.274 0 9.034V1.86C0 .62.62 0 1.86 0h7.176Zm13.105 0C23.38 0 24 .62 24 1.86v7.175c0 1.24-.62 1.86-1.86 1.86h-7.176c-1.24 0-1.86-.62-1.86-1.86V1.86c0-1.24.62-1.859 1.86-1.859h7.177Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "qrcode"}) } }